import { withSearch } from '@elastic/react-search-ui';
import DropDownFacetFilters from '../../../components/filter/DropDownFacetFilter';

function HeritageGatewayMonumentTypeFilter({
  setFilter,
  removeFilter,
  filters,
  facets,
}) {
  return (
    <DropDownFacetFilters
      facets={facets}
      fieldId="monumentType"
      filters={filters}
      id="monument-type"
      label="Type"
      removeFilter={removeFilter}
      setFilter={setFilter}
      sort={true}
    />
  );
}

export default withSearch(({ setFilter, removeFilter, filters, facets }) => ({
  setFilter,
  removeFilter,
  filters,
  facets,
}))(HeritageGatewayMonumentTypeFilter);
